var scope_0 = require('/builds/claromentis/design/design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/595a5beb9c999f172f524ee8ed484c84.js').default;
var scope_1 = require('/builds/claromentis/design/design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a3b72d8cc94ab385174aad1baada02c1.js').default;
var scope_2 = require('/builds/claromentis/design/design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b5b922209fadf1b0156a0bd43515061d.js').default;
var scope_3 = require('/builds/claromentis/design/design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/da65114f248a2736e89532d6d4a3c668.js').default;
var scope_4 = require('/builds/claromentis/design/design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    